module.exports = __webpack_public_path__ + "static/img/talentAD4.c74fde2d.png";